module.exports = __webpack_public_path__ + "media/components/listings/listing/company/idx-5780ed05d93b9fa2418f9db49aacf7ab.png";